import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName?: string;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  open,
  onClose,
  onConfirm,
  userName,
}) => {
  const { t } = useTranslation();
  const titleId = useId();
  if (!open) return null;
  return (
    <div className="modal modal-open">
      <div className="modal-box" role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <h3 id={titleId} className="font-bold text-lg mb-4">
          {t('admin:users.deleteTitle')}
        </h3>
        <p>{t('admin:users.deleteConfirm', { name: userName })}</p>
        <div className="modal-action">
          <button className="btn" onClick={onClose}>
            {t('admin:users.cancel')}
          </button>
          <button className="btn btn-error ml-2" onClick={onConfirm}>
            {t('admin:users.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
